import { FunctionComponent, MouseEvent } from 'react';
import { Badge } from 'dibs-elements/exports/Badge';
import { SeoLink } from 'dibs-elements/exports/SeoLink';
import styles from './SharedRelatedItems.scss';
import classnames from 'classnames';

import { BuySharedRelatedPages_buyPage } from '../../buy/BuySharedRelatedPages/__generated__/BuySharedRelatedPages_buyPage.graphql';
import { SbSharedRelatedSearches_itemSearch } from '../../finding/SbSharedRelatedSearches/__generated__/SbSharedRelatedSearches_itemSearch.graphql';

type Props = {
    relatedItems:
        | BuySharedRelatedPages_buyPage['relatedBuyPages']
        | SbSharedRelatedSearches_itemSearch['relatedSearches'];
    onClick?: (index: number, event: MouseEvent) => void;
    isFullWidth?: boolean | null;
    isLinkable?: boolean;
    dataTn?: string;
};

export const SharedRelatedItems: FunctionComponent<Props> = ({
    relatedItems,
    onClick = () => {},
    isFullWidth,
    isLinkable,
    dataTn,
}) => {
    const wrapperClasses = classnames(styles.wrapper, { [styles.fullWidthWrapper]: isFullWidth });
    const innerWrapperClasses = classnames(styles.innerWrapper, {
        [styles.fullWidthInnerWrapper]: isFullWidth,
    });

    if (!relatedItems) {
        return null;
    }

    return (
        <div className={wrapperClasses}>
            <div className={innerWrapperClasses}>
                {relatedItems.map((item, index) => {
                    const { url, anchorText } = item || {};
                    if (url && anchorText) {
                        return (
                            <SeoLink
                                key={url}
                                linkData={{ path: url, isLinkable }}
                                onClick={event => onClick(index, event)}
                                dataTn={dataTn}
                                className={`${styles.link} ${styles.specify}`}
                            >
                                <Badge type="pill" size="medium-regular" interactive>
                                    {anchorText}
                                </Badge>
                            </SeoLink>
                        );
                    }
                    return null;
                })}
            </div>
        </div>
    );
};

SharedRelatedItems.defaultProps = {
    isLinkable: true,
};
